import {BaseConfig} from 'config';
import {useMemo} from 'react';
import {matchPath, useLocation} from 'react-router-dom';

export const useHideMobileMenu = () => {
    const customerConfig = BaseConfig.USER_CUSTOMER;

    const location = useLocation();

    const hideMenu = useMemo(() => {
        if (customerConfig && customerConfig?.hideMobileMenu) {
            return customerConfig.hideMobileMenu.some((path) => {
                return matchPath(path, location.pathname) ? true : false;
            });
        }
    }, [location]);

    return {
        hideMenu,
    };
};
